import React from 'react';

const CardDetails = ({
    claimedValue,
    claimedLabel,
    processingValue,
    processingLabel,
    unclaimedValue,
    unclaimedLabel,
    icon,
    label
}) => {
    return (
        <div>
            <div className="bg-white border border-gray-300 rounded-lg px-3 md:px-5 lg:px-8 py-6 w-[100%] md:w-[82%] lg:w-[85%] xl:w-[63%]">
                <div className="flex items-center mb-2">
                    <div className="flex items-center space-x-2">
                        <div style={{ width: '20px', height: '20px' }}>
                            {React.cloneElement(icon, {
                                width: '100%',
                                height: '100%'
                            })}
                        </div>

                        <div>
                            <span className="font-bold text-black text-sm lg:text-base">
                                {label}
                            </span>
                        </div>
                    </div>
                </div>
                <div
                    className={`flex space-x-14 md:space-x-28 lg:space-x-32 xl:space-x-44`}
                >
                    <div className="flex flex-col items-start  ">
                        <p className=" text-base md:text-lg font-semibold text-primary">
                            {claimedValue}
                        </p>
                        <p className=" text-xs md:text-sm">{claimedLabel}</p>
                    </div>

                    {processingLabel.length === 0 && (
                        <>
                            <div className="flex flex-col items-start  border-l-2 border-gray-300">
                                <p className=" text-base lg:text-lg font-semibold text-primary md:ml-4 ml-2">
                                    {unclaimedValue}
                                </p>
                                <p className=" text-xs md:text-sm ml-2 md:ml-4">
                                    {unclaimedLabel}
                                </p>
                            </div>
                        </>
                    )}

                    {processingLabel.length > 0 && (
                        <>
                            <div className="flex flex-col items-start  border-l-2 border-gray-300">
                                <p className=" text-base lg:text-lg font-semibold text-primary md:ml-4 ml-2">
                                    {processingValue}
                                </p>
                                <p className=" text-xs md:text-sm md:ml-4 ml-2">
                                    {processingLabel}
                                </p>
                            </div>

                            <div className="flex flex-col items-start  border-l-2 border-gray-300">
                                <p className="text-base lg:text-lg font-semibold text-primary md:ml-4 ml-2">
                                    {unclaimedValue}
                                </p>
                                <p className=" text-xs md:text-sm md:ml-4 ml-2">
                                    {unclaimedLabel}
                                </p>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardDetails;
